export default __webpack_public_path__ + "static/media/flow6.db003f75.svg";